import Button from '../../components/button/Button.jsx'
import { Form, Formik } from 'formik'
import './configuration.scss'
import NewInput from '../../components/input/NewInput.jsx'
import UI_TEXT from '../../utility/ui.text.js'
import { ROUTES_PATH, UI_CONSTANT } from '../../utility/constants.js'
import BreadCrumbs from '../../components/breadcrumb/Breadcrumb.jsx'
import * as Yup from 'yup'
import { useCallback, useEffect, useState } from 'react'
import { handleEmail } from '../../utility/genricFunction.js'
import { useDispatch, useSelector } from 'react-redux'
import { VALIDATION_MESSAGES } from '../../utility/constantValidationMessages.js'
import { editConfiguration, getConfiguration } from '../../store/builders/configuration/configuration.builder.js'
import PasswordInput from '../../components/input/PasswordInput.jsx'
import Loader from '../../components/loader/Loader.jsx'

const Configuration = () => {
  const configurationData = useSelector((state) => state?.configuration?.configurationData?.configration)
  const { loading } = useSelector((state) => state?.configuration)
  const dispatch = useDispatch()
  const [initialValues, setInitialValues] = useState(null)

  useEffect(() => {
    dispatch(getConfiguration())
    return () => dispatch({ type: 'configuration/clearExtraReducers' })
  }, [dispatch])

  const checkConfigurationData = useCallback(() => {
    if (configurationData) {
      setInitialValues({
        email: configurationData?.email || '',
        password: configurationData?.password || '',
        branchTemplate: configurationData?.branch_template || '',
        studentTemplate: configurationData?.student_template || '',
        facultyTemplate: configurationData?.faculty_template || '',
        facultyBillingTemplate: configurationData?.faculty_billing_template || '',
        forgotPasswordTemplate: configurationData?.forgot_password_template || '',
        timetableTemplate: configurationData?.timetable_template || '',
        branchEmailSubject: configurationData?.branch_email_subject || '',
        studentEmailSubject: configurationData?.student_email_subject || '',
        facultyEmailSubject: configurationData?.faculty_email_subject || '',
        facultyBillingEmailSubject: configurationData?.faculty_billing_email_subject || '',
        forgotPasswordEmailSubject: configurationData?.forgot_password_email_subject || '',
        timetableEmailSubject: configurationData?.timetable_email_subject || '',
        contactUsEmail: configurationData?.contact_us_email || '',
        contactUsPhone: configurationData?.contact_us_phone || ''
        
      })
    }
  },[configurationData, dispatch])
  
  useEffect(() => {
    checkConfigurationData()
  }, [configurationData, dispatch])

  function handleFormSubmit(values) {
    const editObj = {
      configuration_id: configurationData?.configuration_id,
      email: values?.email || '',
      branch_email_subject: values?.branchEmailSubject || '',
      student_email_subject: values?.studentEmailSubject || '',
      faculty_email_subject: values?.facultyEmailSubject || '',
      faculty_billing_email_subject: values?.facultyBillingEmailSubject || '',
      forgot_password_email_subject: values?.forgotPasswordEmailSubject || '',
      timetable_email_subject: values?.timetableEmailSubject || '',
      password: values?.password || '',
      branch_template: values?.branchTemplate || '',
      student_template: values?.studentTemplate || '',
      faculty_template: values?.facultyTemplate || '',
      faculty_billing_template: values?.facultyBillingTemplate || '',
      forgot_password_template: values?.forgotPasswordTemplate || '',
      timetable_template: values?.timetableTemplate || '',
      contact_us_email: values?.contactUsEmail || '',
      contact_us_phone: values?.contactUsPhone || ''
    }
    dispatch(editConfiguration(editObj))
  }

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.CONFIGURATION.CONFIGURATION,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: UI_CONSTANT.CONFIGURATION.CONFIGURATION,
      link: ROUTES_PATH.CONFIGURATION,
    },
  ]

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .matches(/\S+@\S+\.\S+/, VALIDATION_MESSAGES.EMAIL_VALID)
      .nullable(),
    // password: Yup.string()
    //   .nullable()
    //   .min(PASSWORD_MIN_LENGTH, VALIDATION_MESSAGES.PASSWORD_VALID)
    //   .matches(
    //     /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
    //     VALIDATION_MESSAGES.PASSWORD_VALID,
    //   ),
  })
  const [blur, setBlur] = useState(false)
  const handleBlur = () => {
    setBlur(true)
  }

  return (
    <>
      {loading && <Loader loading={loading} />}

      {<Loader loading={loading} /> && (
        <div className='configurationForm-wrapper'>
          {initialValues && (
            <Formik
              validationSchema={validationSchema}
              initialValues={initialValues}
              onSubmit={(values) => {
                handleFormSubmit(values)
              }}
              enableReinitialize
            >
              {({ values, handleChange, handleSubmit }) => (
                <Form aria-autocomplete='none'>
                  <div className='configurationForm-header'>
                    <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />

                    <div className='configurationForm-header-right'>
                      <Button customClassName={'save-btn'} onClick={handleSubmit} disabled={loading}>
                        {loading ? UI_CONSTANT.LOADING : UI_CONSTANT.SAVE}
                      </Button>
                    </div>
                  </div>
                  <div className='configurationForm'>
                    <div className='configurationForm-inner-header'>
                      <h1>{UI_CONSTANT.CONFIGURATION.CONFIGURATION}</h1>
                      <p>{UI_TEXT.BRANCH_PAGE.FORM_DESCRIPTION}</p>
                    </div>

                    <div className='separatorLine'></div>

                    <div className='configurationForm-input-fields'>
                      {/* <div className='empty-space'></div> */}
                      <div className='configuration-input-row'>
                        <NewInput
                          label='Email'
                          placeholder='Enter email'
                          value={values?.email}
                          name='email'
                          width={'100%'}
                          type={'email'}
                          maxLength={50}
                          onInput={handleEmail}
                        />

                        <PasswordInput
                          label='Password'
                          placeholder='Enter user password'
                          name='password'
                          width={'100%'}
                          value={values?.password}
                          // onInput={handlePassword}
                          autoComplete='new-password'
                          onBlur={(e) => handleBlur(e)}
                          blur={blur}
                        />
                      </div>

                      <NewInput
                        label='Branch Email Subject'
                        placeholder='Enter branch email subject'
                        value={values?.branchEmailSubject}
                        name='branchEmailSubject'
                        width={'100%'}
                        maxLength={100}
                        onChange={handleChange}
                      />

                      <div className='configurationForm-input-textarea'>
                        <label htmlFor='branchTemplate'>Branch Template</label>
                        <textarea
                          id='branchTemplate'
                          placeholder='Enter branch template...'
                          rows={5}
                          cols={50}
                          value={values.branchTemplate}
                          name='branchTemplate'
                          onChange={handleChange}
                        />
                      </div>
                      
                      <NewInput
                        label='Student Email Subject'
                        placeholder='Enter student email subject'
                        value={values?.studentEmailSubject}
                        name='studentEmailSubject'
                        width={'100%'}
                        maxLength={100}
                        onChange={handleChange}
                      />
                      <div className='configurationForm-input-textarea'>
                        <label htmlFor='studentTemplate'>Student Template</label>
                        <textarea
                          id='studentTemplate'
                          placeholder='Enter student template...'
                          rows={5}
                          cols={50}
                          value={values.studentTemplate}
                          name='studentTemplate'
                          onChange={handleChange}
                        />
                      </div>

                      <NewInput
                        label='Faculty Email Subject'
                        placeholder='Enter faculty email subject'
                        value={values?.facultyEmailSubject}
                        name='facultyEmailSubject'
                        width={'100%'}
                        maxLength={100}
                        onChange={handleChange}
                      />
                      <div className='configurationForm-input-textarea'>
                        <label htmlFor='facultyTemplate'>Faculty Template</label>
                        <textarea
                          id='facultyTemplate'
                          placeholder='Enter faculty template...'
                          rows={5}
                          cols={50}
                          value={values.facultyTemplate}
                          name='facultyTemplate'
                          onChange={handleChange}
                        />
                      </div>

                      <NewInput
                        label='Faculty Billing Email Subject'
                        placeholder='Enter faculty billing email subject'
                        value={values?.facultyBillingEmailSubject}
                        name='facultyBillingEmailSubject'
                        width={'100%'}
                        maxLength={100}
                        onChange={handleChange}
                      />
                      <div className='configurationForm-input-textarea'>
                        <label htmlFor='facultyBillingTemplate'>Faculty Billing Template</label>
                        <textarea
                          id='facultyBillingTemplate'
                          placeholder='Enter faculty billing template...'
                          rows={5}
                          cols={50}
                          value={values.facultyBillingTemplate}
                          name='facultyBillingTemplate'
                          onChange={handleChange}
                        />
                      </div>

                      <NewInput
                        label='Forgot Password Email Subject'
                        placeholder='Enter forgot password email subject'
                        value={values?.forgotPasswordEmailSubject}
                        name='forgotPasswordEmailSubject'
                        width={'100%'}
                        maxLength={100}
                        onChange={handleChange}
                      />
                      <div className='configurationForm-input-textarea'>
                        <label htmlFor='forgotPasswordTemplate'>Forgot Password Template</label>
                        <textarea
                          id='forgotPasswordTemplate'
                          placeholder='Enter forgot password template...'
                          rows={5}
                          cols={50}
                          value={values.forgotPasswordTemplate}
                          name='forgotPasswordTemplate'
                          onChange={handleChange}
                        />
                      </div>

                      <NewInput
                        label='Timetable Email Subject'
                        placeholder='Enter timetable email subject'
                        value={values?.timetableEmailSubject}
                        name='timetableEmailSubject'
                        width={'100%'}
                        maxLength={100}
                        onChange={handleChange}
                      />
                      <div className='configurationForm-input-textarea'>
                        <label htmlFor='timetableTemplate'>Timetable Template</label>
                        <textarea
                          id='timetableTemplate'
                          placeholder='Enter timetable template...'
                          rows={5}
                          cols={50}
                          value={values.timetableTemplate}
                          name='timetableTemplate'
                          onChange={handleChange}
                        />
                      </div>
                      <div className='configuration-input-row'>
                      <NewInput
                        label='Contact us email'
                        placeholder='Enter contact us email'
                        value={values?.contactUsEmail}
                        name='contactUsEmail'
                        width={'100%'}
                        maxLength={100}
                        onChange={handleChange}
                      />
                        <NewInput
                        label='Contact us phone'
                        placeholder='Enter contact us phone'
                        value={values?.contactUsPhone}
                        name='contactUsPhone'
                        width={'100%'}
                        maxLength={100}
                        onChange={handleChange}
                      />
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          )}
        </div>
      )}
    </>
  )
}

export default Configuration
